<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">Consultas</h1>
        <p class="nd-page-kicker">Agenda, atendimentos e retornos.</p>
      </div>
      <v-btn id="btnNew" type="button" color="primary" elevation="0" to="/consultas/novo">
        <v-icon left small>mdi-plus</v-icon>
        Incluir
      </v-btn>
    </header>

    <module-stat-grid module="appointments" :items="dataList.data" :count="dataList.count" />

    <v-card class="nd-section-card">
      <div class="nd-table-toolbar">
        <div>
          <div class="nd-table-toolbar__title">Consultas</div>
          <div class="nd-table-toolbar__subtitle">Filtre e acompanhe a agenda operacional.</div>
        </div>
        <v-form class="nd-table-toolbar__actions nd-table-toolbar__actions--wide" @submit.prevent="load()">
          <v-text-field
            dense
            id="patientName"
            placeholder="Buscar paciente"
            prepend-inner-icon="mdi-magnify"
            v-model="dataList.filter.patientName" hide-details="auto"
            outlined
          ></v-text-field>
          <v-text-field dense id="date" placeholder="Data" v-model="dataList.filter.date" hide-details="auto" outlined></v-text-field>
          <v-btn id="btnFilter" type="submit" outlined color="primary" elevation="0">
            <v-icon left size="18">mdi-filter-outline</v-icon>
            Filtrar
          </v-btn>
        </v-form>
      </div>
            <v-data-table
              :headers="dataList.headers"
              :items="dataList.data"
              @update:items-per-page="pageSizeChanged"
              @update:page="pageChanged"
              :server-items-length="dataList.count"
              :disable-sort="true"
              :loading="dataList.loading"
              no-data-text="Nenhuma consulta encontrada"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              :options.sync="dataList.options"
              :footer-props="dataList.footerOptions"
            >
              <template v-slot:[`item.patient.name`]="{ item }">
                <div class="nd-entity-cell">
                  <span class="nd-entity-mark">{{ item.patient && item.patient.name ? item.patient.name.charAt(0) : "C" }}</span>
                  <div>
                    <strong>{{ item.patient ? item.patient.name : "—" }}</strong>
                    <small>ID {{ item.id }}</small>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.scheduledDate`]="{ item }">
                {{ formatDate(item.scheduledDate || item.date) }}
              </template>

              <template v-slot:[`item.state`]="{ item }">
                <v-chip small label :class="stateClass(item.state)">
                  {{ stateLabel(item.state) }}
                </v-chip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="row-actions">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="viewItem(item)">
                        <v-icon size="19">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Atualizar consulta</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="deleteAppointment(item)">
                        <v-icon size="19">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remover consulta</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ModuleStatGrid from "@/components/ModuleStatGrid.vue";
import Vue from "vue";
import VueLodash from "vue-lodash";
import _ from "lodash";
import axios from "axios";

import object from "@/common/util/object";

Vue.use(VueLodash, { lodash: _ });

export default {
  components: { ModuleStatGrid },
  name: "AppointmentsList",

  data: () => ({
    dataset: {
      data: {},
    },
    dataList: {
      filter: {
        patientName: "",
        date: "",
      },
      headers: [
        { text: "Paciente", value: "patient.name" },
        { text: "Data Agendada", value: "scheduledDate" },
        { text: "Horário", value: "scheduledTime" },
        { text: "Procedimento", value: "procedure.name" },
        { text: "Estado", value: "state" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      data: [],
      loading: false,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [false],
      },
      footerOptions: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        pageText: "{0}-{1} de {2}",
      },
    },
  }),

  created() {
    this.load();
  },

  computed: {
    nextAppointmentDate() {
      const dates = this.dataList.data
        .map((item) => item.scheduledDate || item.date)
        .filter(Boolean)
        .sort();
      return dates.length ? new Date(dates[0]).toLocaleDateString("pt-BR") : "-";
    },
  },

  watch: {
    "dataList.data": {
      handler(newVal) {},
      deep: true,
      immediate: true,
    },
  },

  methods: {
    pageChanged(page) {
      this.dataList.options.page = page;
      this.load();
    },

    pageSizeChanged(size) {
      this.dataList.options.itemsPerPage = size;
      this.load(true);
    },

    async load() {
      const search = Object.fromEntries(
        Object.entries(this.dataList.filter).filter(([_, v]) => v)
      );

      const params = {
        page: this.dataList.options.page,
        limit: this.dataList.options.itemsPerPage,
      };

      if (!object.isEmpty(search)) {
        params.search = search;
      }

      this.dataList.loading = true;

      try {
        const result = await axios.get("/appointments", {
          params: params,
        });

        this.dataList.data = result.data.data;
        this.dataList.count = result.data.count;
      } catch (error) {
        this.$dialog.notify.error(
          "Ocorreu um erro ao encontrar as consultas, reinicie sua sessão e tente novamente!",
          {
            position: "top-right",
            timeout: 5000,
          }
        );
      } finally {
        this.dataList.loading = false;
      }
    },

    viewItem(item) {
      this.$router.push(`/consultas/${item.id}`);
    },

    formatDate(value) {
      if (!value) return "—";
      const isoDate = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoDate) return `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}`;
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("pt-BR");
    },

    stateLabel(state) {
      const labels = {
        2: "Agendado",
        10: "Finalizado",
        11: "Cancelado",
        12: "Confirmado",
      };
      return labels[Number(state)] || "Não informado";
    },

    stateClass(state) {
      const classes = {
        2: "nd-status-chip nd-status-chip--scheduled",
        10: "nd-status-chip nd-status-chip--done",
        11: "nd-status-chip nd-status-chip--canceled",
        12: "nd-status-chip nd-status-chip--confirmed",
      };
      return classes[Number(state)] || "nd-status-chip";
    },

    async deleteAppointment(item) {
      const proceed = await this.$dialog.confirm({
        text: `Deseja realmente remover a consulta "${item.id}"?`,
        title: "Confirmar Exclusão",
        actions: {
          false: "Cancelar",
          true: { text: "Remover", color: "error" },
        },
      });

      if (proceed) {
        this.dataList.loading = true;
        try {
          await axios.delete(`/appointments/${item.id}`);
          this.$dialog.notify.info(`Consulta "${item.id}" removida com sucesso!`, {
            position: "top-right",
            timeout: 2000,
          });
          this.load();
        } catch (error) {
          console.error("Erro ao remover consulta:", error);
          this.$dialog.notify.error(
            "Ocorreu um erro ao remover a consulta. Tente novamente mais tarde.",
            {
              position: "top-right",
              timeout: 5000,
            }
          );
        } finally {
          this.dataList.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .nd-status-chip {
  background: #f3f4f2 !important;
  color: #526159 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

::v-deep .nd-status-chip--scheduled {
  background: #f1e8ff !important;
  color: #8f52d1 !important;
}

::v-deep .nd-status-chip--confirmed {
  background: #e6f4ff !important;
  color: #1f79c7 !important;
}

::v-deep .nd-status-chip--done {
  background: #e7f7ee !important;
  color: #168a4d !important;
}

::v-deep .nd-status-chip--canceled {
  background: #ffeceb !important;
  color: #c74646 !important;
}
</style>
